import React, { useEffect, useRef, useState } from 'react';

function ProgressBar({
    durationMs,
    endsAtMs,
    value,
    max,
    variant = 'default',
    paused = false,
}) {
    const [fraction, setFraction] = useState(0);
    const fractionRef = useRef(0);
    const rafRef = useRef();

    useEffect(() => {
        if (rafRef.current) {
            cancelAnimationFrame(rafRef.current);
        }

        if (durationMs != null && endsAtMs != null) {
            const clampFraction = (val) => Math.max(0, Math.min(1, val));
            const updateFraction = () => {
                if (paused) return fractionRef.current;
                const now = Date.now();
                const remainingMs = Math.max(0, endsAtMs - now);
                const currentFraction = durationMs > 0
                    ? clampFraction(remainingMs / durationMs)
                    : 0;
                fractionRef.current = currentFraction;
                setFraction(currentFraction);
                return remainingMs;
            };

            const tick = () => {
                const remainingMs = updateFraction();

                if (remainingMs > 0) {
                    rafRef.current = requestAnimationFrame(tick);
                }
            };

            updateFraction();
            rafRef.current = requestAnimationFrame(tick);
            return () => cancelAnimationFrame(rafRef.current);
        }

        if (max != null && max !== 0) {
            const fallback = Math.max(0, Math.min(1, (value ?? 0) / max));
            fractionRef.current = fallback;
            setFraction(fallback);
        } else {
            fractionRef.current = 0;
            setFraction(0);
        }

        return () => {};
    }, [durationMs, endsAtMs, paused, value, max]);

    return (
        <div className="progress-wrapper">
            <div
                className={`progress ${variant === 'prediction' ? 'prediction' : ''}`}
                role="progressbar"
                aria-valuenow={fraction * 100}
                aria-valuemin="0"
                aria-valuemax="100"
            >
                <div
                    className="progress-bar from-right"
                    style={{ transform: `scaleX(${fraction})` }}
                />
            </div>
        </div>
    );
}

export default ProgressBar;
